import { render, staticRenderFns } from "./CreatePlusTop.vue?vue&type=template&id=233ee4a0&scoped=true&"
import script from "./CreatePlusTop.vue?vue&type=script&lang=js&"
export * from "./CreatePlusTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ee4a0",
  null
  
)

export default component.exports